var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('Alerts'),_c('v-content',[(_vm.mostrarDrawer && _vm.loggedIn)?_c('NavigationDrawer',{ref:"drawer"}):_vm._e(),(_vm.mostrarDrawer)?_c('Toolbar'):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }